<div class="leaderboard-wrapper" [ngClass]="{'is-in-dialog': inDialog, 'is-in-profile' : isInProfile}">
  @if (!inDialog) {
    <div class="leaderboard-header">
      <div class="leaderboard-header-title">Leaderboard</div>
    </div>
  }

  @if (leaderboardItemsPassedIn?.length) {
    <div class="leaderboard-content">
      <div class="leaderboard-switch">
        @switch (leaderboardMode) {
          @case ('team-leaderboard') {
            <div class="leaderboard-case-wrapper">
              <div class="team-leaders-list">
                @for (_boardTeamItem of leaderboardItemsPassedIn; track _boardTeamItem; let i = $index) {
                  <div class="team-leader-item">
                    <div class="leader-item-team-info">
                      <div class="item-team-title">{{ _boardTeamItem.title }}</div>
                      @if (!useScoreWithoutPipe) {
                        <div class="item-team-score">{{ _boardTeamItem?.score | number : '1.2-2' }}</div>
                      }
                      @if (useScoreWithoutPipe) {
                        <div class="item-team-score">{{ _boardTeamItem?.score }}</div>
                      }
                    </div>
                    <div class="leader-item-team-members-list">
                      @if (_boardTeamItem?.members?.length) {
                        <div class="team-members-list-header">
                          <div class="rank-col"></div>
                          <div class="title-col"></div>
                          <div class="credits-col">Credits</div>
                          <div class="score-col">Score</div>
                        </div>
                        @for (_member of _boardTeamItem.members; track _member; let j = $index) {
                          <div class="team-member-item">
                            <div class="rank-col member-item-rank">{{ j + 1 }}</div>
                            <div class="title-col member-item-title" [matTooltip]="_member?.name">{{ _member?.name }}</div>
                            @if (_member?.credits >= 0) {
                              <div class="credits-col member-item-credits">{{ _member?.credits }}</div>
                            }
                            @if (!useScoreWithoutPipe) {
                              <div class="score-col member-item-score">{{ _member?.score | number : '1.2-2' }}</div>
                            }
                            @if (useScoreWithoutPipe) {
                              <div class="score-col member-item-score">{{ _member?.score }}</div>
                            }
                          </div>
                        }
                      }
                      @if (!_boardTeamItem?.members?.length) {
                        <p class="no-members">No members on team</p>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @default {
            <div class="leaderboard-case-wrapper">
              <div class="top-3-leaders-wrapper">
                <div class="top-3-leaders-list">
                  @for (_topLeader of topLeaders; track _topLeader; let i = $index) {
                    <div class="top-3-leader-item">
                      <div class="top-3-item-rank-col">
                        <div class="top-3-item-rank-badge" [ngClass]="{'silver-medal': i === 1, 'bronze-medal' : i === 2}"></div>
                        <div class="top-3-item-rank">{{ _topLeader.rank }}</div>
                      </div>
                      <div class="top-3-item-data-col">
                        <div class="top-3-item-data-image-wrapper">
                          @if (_topLeader?.image) {
                            <img class="top-3-item-data-image" [src]="_topLeader.image" onerror="this.src='/uploads/system_images/icons/icons8-test-account-50.svg';">
                          }
                          @if (!_topLeader?.image) {
                            <img class="top-3-item-data-image" src="/uploads/system_images/icons/icons8-test-account-50.svg">
                          }
                        </div>
                        <div class="top-3-item-data-title">{{ _topLeader.title }}</div>
                        @if (_topLeader?.credits >= 0) {
                          <div class="top-3-item-data-credits">Credits: {{ _topLeader?.credits }}</div>
                        }
                        @if (!useScoreWithoutPipe) {
                          <div class="top-3-item-data-score">Score: {{ _topLeader?.score | number : '1.2-2' }}</div>
                        }
                        @if (useScoreWithoutPipe) {
                          <div class="top-3-item-data-score">Score: {{ _topLeader?.score }}</div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="normal-leaders-wrapper">
                <div class="normal-leaders-list">
                  <!-- Don't show first 3 because they are in top 3 list -->
                  @for (_boardItem of leaderboardItemsPassedIn; track _boardItem; let i = $index) {
                    @if (_boardItem?.rank > 3) {
                      <div class="normal-leader-item">
                        <div class="normal-item-rank-col">{{ _boardItem.rank }}</div>
                        <div class="normal-item-data-col">
                          <div class="data-col-left-col">
                            <div class="normal-item-image-wrapper">
                              @if (_boardItem?.image) {
                                <img class="normal-item-image" [src]="_boardItem.image" onerror="this.src='/uploads/system_images/icons/icons8-test-account-50.svg';">
                              }
                              @if (!_boardItem?.image) {
                                <img class="normal-item-image" src="/uploads/system_images/icons/icons8-test-account-50.svg">
                              }
                            </div>
                          </div>
                          <div class="data-col-right-col">
                            <div class="normal-item-title give-mr">{{ _boardItem.title }}</div>
                            @if (_boardItem?.credits >= 0) {
                              <div class="normal-item-credits give-mr">Credits: {{ _boardItem?.credits }}</div>
                            }
                            @if (!useScoreWithoutPipe) {
                              <div class="normal-item-score">Score: {{ _boardItem?.score | number : '1.2-2' }}</div>
                            }
                            @if (useScoreWithoutPipe) {
                              <div class="normal-item-score">Score: {{ _boardItem?.score }}</div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }

  @if (!leaderboardItemsPassedIn?.length) {
    <div class="missing-leaderboard-data-content">
      <p class="no-data">No leaderboard data to view</p>
    </div>
  }
</div>